<template>
  <div class="single-portion">
    <b-button
      class="d-flex justify-content-between"
      :class="{ 'attach-pressed': btnPressed }"
    >
      <div
        class="d-flex align-items-center flex-fill"
        @click="elementSelected"
      >
        <i
          class="icon-block-solid primary-dark-color mr-2"
          aria-hidden="true"
        />
        <span>{{ `${sampleNumber}-${portion.porPortionnumber}` }}</span>
        <vtBubble
          v-if="portion.attachmentsCount"
          :number="portion.attachmentsCount"
          :type="false"
          :tooltip="' '+$tc('global.file',2)"
          style="margin-top: 2px"
        />
      </div>
      <div
        v-show="showArrow"
        class="attach-arrow"
        @click="hideSubportions = !hideSubportions"
      >
        <i
          v-show="hideSubportions"
          class="far fa-chevron-down"
          aria-hidden="true"
        />
        <i
          v-show="!hideSubportions"
          class="far fa-chevron-up"
          aria-hidden="true"
        />
      </div>
    </b-button>

    <div
      v-for="(subportion, subportionIndex) in portion.subportions"
      :key="subportionIndex"
      class="element subportions ml-2"
      :class="{'attach-display': hideSubportions}"
    >
      <subportion-tree
        ref="subportionTree"
        :laboratory-id="laboratoryId"
        :case-id="caseId"
        :sample-id="sampleId"
        :portion-id="entityId"
        :sample-number="sampleNumber"
        :portion-number="portion.porPortionnumber"
        :subportion="subportion"
        @child-selected="$emit('child-selected', $event)"
      />
    </div>
  </div>
</template>

<script>
import VtBubble from '@/components/common/VtBubble'
import SubportionTree from './SubportionTree'
import portionAttachmentService from '@/api/resources/attachment/portionAttachmentService'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import { PortionOperationGuardMixin } from '@/api/operations/mixins/guards/portion-operation-guard.mixin'

export default {
    name: 'PortionTree',
    components: {
        SubportionTree,
        VtBubble
    },
    mixins: [
        PortionOperationGuardMixin
    ],
    props: {
        laboratoryId: { type: Number, required: true },
        sampleNumber: { type: String, required: true },
        caseId: { type: Number, required: true },
        sampleId: { type: Number, required: true },
        portion: { type: Object, required: true }
    },
    data() {
        return {
            showArrow: true,
            hideSubportions: false,
            btnPressed: false,
            attachments: [],
            elementIcon: 'icon-block-solid',
            attachmentEntityType: ATTACHMENT_ENTITY_TYPE.PORTION
        }
    },
    computed: {
        entityId() {
            return this.portion.porId
        },
        entityDisplay() {
            return this.portion.porLabel
        },
        portionId() {
            return this.portion.porId
        },
        userHasAttachOperation() {
            return this.$_canAttachDocumentToPortion()
        },
        canBeAttached() {
            return this.$_canBeDocumentAttachedToPortion(this.portion)
        }
    },
    methods: {
        async elementSelected() {
            this.btnPressed = true
            this.attachments = await portionAttachmentService.getAttachments(this.laboratoryId, this.caseId, this.sampleId, this.entityId)
            this.$emit('child-selected', this)
        },
        deselect() {
            this.btnPressed = false
        },
        findSubportionTree(subportionId) {
            return this.$refs.subportionTree?.find((child) => child.entityId === subportionId)
        }
    }
}
</script>
